import type { SearchContext } from '@shared/types/types';
import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';

/**
 *
 *
 */
const ASSORTMENTS_WITH_TOP_INFO = [
    'Haushaltsgeräte',
    'Unterhaltungselektronik',
    'Optik',
    'Kommunikation',
    'Reinigungsgeräte',
    'Klima',
    'Bürotechnik',
    'Fahrzeuge',
    'Gartengeräte',
    'Heizen',
    'Sportausrüstung',
    'Zahnpflege',
    'Elektroinstallation',
] as const;

const ADDITIONAL_ASSORTMENTS = ['Möbel', 'Dekoration', 'Aufbewahrung', 'Heimtextilien'] as const;

const ASSORTMENTS_SET = new Set(ASSORTMENTS_WITH_TOP_INFO.map((item) => item.toLowerCase()));
const ADDITIONAL_SET = new Set(ADDITIONAL_ASSORTMENTS.map((item) => item.toLowerCase()));

function normalizeAssortment(searchContext: SearchContext | undefined): string | undefined {
    const assortment = searchContext?.assortment;
    return assortment ? assortment.toLowerCase() : undefined;
}

export function shouldShowTopInfos(searchContext?: SearchContext, onex?: OnEx): boolean {
    const normalized = normalizeAssortment(searchContext);
    if (!normalized) return false;

    const isBaseAssortment = ASSORTMENTS_SET.has(normalized);
    if (isBaseAssortment) return true;

    const isExperimentAssortment = ADDITIONAL_SET.has(normalized);
    const isInTestGroup = onex?.isExperimentGroup('CLEAN_TILE_V2', 'E3867B') || false;
    return isExperimentAssortment && isInTestGroup;
}

/**
 *
 */
export function isInExperimentSegment(searchContext?: SearchContext, onex?: OnEx): boolean {
    const normalized = normalizeAssortment(searchContext);
    if (!normalized) return false;

    const isBaseAssortment = ASSORTMENTS_SET.has(normalized);
    if (isBaseAssortment) return false;

    const isExperimentAssortment = ADDITIONAL_SET.has(normalized);
    const isExperimentActive = onex?.isExperimentActive('CLEAN_TILE_V2') || false;
    return isExperimentAssortment && isExperimentActive;
}
